export const fluency = ["Malayalam", "English", "Hindi", "Arabic"];
